module.exports = __webpack_public_path__ + "img/vertical_3_4_8017.677bb594.png";